<template>
  <b-form @submit.prevent="onSubmitForm">
    <b-row id="code-template-info">
      <b-col>
        <b-card no-body class="container-card">
          <div id="tabs-template" class="overflow-wrp">
            <b-tabs v-model="tabIndex" @activate-tab="onChangeTab">
              <b-tab>
                <template #title>
                  <span class="d-none d-sm-inline title-tab">Information</span>
                </template>
                <infomation-template
                  :form-modal="formModal"
                  @onSave="onSaveModalChoosePrivilege"
                  @onSaveImage="onSaveModalSelectImage"
                  @onChange="onChangeFormData"
                  @onCropImage="onCropImage"
                />
              </b-tab>
              <b-tab>
                <template #title>
                  <span class="d-none d-sm-inline title-tab">Content</span>
                </template>
                <content-template
                  :form-modal="formModal"
                  :editor-select-id="editorSelectId"
                  @onSelectEditor="onSelectEditor"
                  @onUploadBg="onUploadBgImage"
                  @onUploadLogo="onUploadLogoImage"
                  @onChange="onChangeFormData"
                />
              </b-tab>
            </b-tabs>
          </div>
        </b-card>
      </b-col>
      <b-col v-if="formModal.templateSelect">
        <b-card no-body class="p-2 container-card container-template">
          <b-row>
            <b-col class="d-flex justify-content-center">
              <div class="editor-button">
                <b-button
                  pill
                  :variant="tabIndex == pageIndex.CONTENT_PAGE ? 'info' : 'secondary'"
                  size="sm"
                  @click="onToggleMode"
                >
                  <span class="mr-2"
                    ><feather-icon
                      :icon="tabIndex == pageIndex.CONTENT_PAGE ? 'EyeIcon' : 'EditIcon'"
                      size="16"
                  /></span>
                  <span>{{ tabIndex == pageIndex.CONTENT_PAGE ? "View" : "Edit" }}</span>
                </b-button>
              </div>

              <template-info
                :template-id="formModal.templateSelect"
                :template-data="formModal"
                :tabindex-active="tabIndex"
                :editor-data="editorData"
                :editor-select-id="editorSelectId"
                :history-data="editorHistoryData.payload"
                @onChangeEditorData="onChangeEditorData"
                @onSelectEditor="onSelectEditor"
                @onUndoEditorData="onUndoEditorData"
                @onReorder="onReorderTemplate"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12">
        <div class="mt-2">
          <div class="d-flex justify-content-center">
            <cancel-button
              class="mr-1"
              @click.native="$router.push('/privilege/code-template/list')"
            />
            <save-button :type="'submit'" class="ml-1" />
          </div>
        </div>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  onBeforeMount,
  ref,
  reactive,
  getCurrentInstance,
} from "@vue/composition-api";
import vSelect from "vue-select";
import useCodeTemplate from "./hooks/useCodeTemplate.js";

import InfomationTemplate from "./components/InfomationTemplate.vue";
import ContentTemplate from "./components/ContentTemplate.vue";

import TemplateInfo from "../code-template-list/components/template/TemplateInfo.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  components: {
    vSelect,
    InfomationTemplate,
    ContentTemplate,
    TemplateInfo,
  },
  setup() {
    const {
      formModal,
      getTemplate,
      onSaveModalChoosePrivilege,
      onSaveModalSelectImage,

      onUploadBgImage,
      onUploadLogoImage,
      onSubmitForm,
      onChangeFormData,
      onUpdateEditor,
      tabIndex,
      editorSelectId,
      editorHistoryData,
      editorData,
      onChangeEditorData,
      onSelectEditor,
      onUndoEditorData,
      onReorderTemplate,
      isEditorMode,
      onToggleMode,
      onChangeTab,

      pageIndex,

      onCropImage
    } = useCodeTemplate();

    return {
      formModal,
      getTemplate,
      onSaveModalChoosePrivilege,
      onSaveModalSelectImage,

      onUploadBgImage,
      onUploadLogoImage,
      onChangeFormData,
      onUpdateEditor,
      tabIndex,
      editorSelectId,
      editorHistoryData,
      editorData,
      onChangeEditorData,
      onSelectEditor,
      onSubmitForm,
      onUndoEditorData,
      onReorderTemplate,
      isEditorMode,
      onToggleMode,
      onChangeTab,

      pageIndex,

      onCropImage
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/privilege/privilege-code-template/code-template-info.css";
.editor-button {
  position: absolute;
  right: 0;
  top: -40px;
  padding: 0;
}
</style>
